import { render, staticRenderFns } from "./configurationPage.vue?vue&type=template&id=7b37dcc6&"
import script from "./configurationPage.vue.ts?vue&type=script&lang=ts&"
export * from "./configurationPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports